import {
  checked,
  conditional,
  email,
  maxLength,
  minLength,
  packageSchemaForFormik,
  phone,
  required,
} from '@ahmdigital/form-validation';
import { includes } from 'lodash/fp';
import { Schema } from '@ahmdigital/form-validation/lib/validators/types';

import { getCookieForMembers } from '../../../utils/cookie-for-members';
import { LEAD_TYPES } from '../../../models/lead-capture/constants';

// undefined passed into the required validator won't override the default validation message
const DEFAULT_VALIDATION_ERROR = undefined;
const { SAVE_AND_RETRIEVE_QUOTE, REQUEST_A_CALL } = LEAD_TYPES;

const REQUIRED_EMAIL_TYPES = [SAVE_AND_RETRIEVE_QUOTE.component];
const REQUIRED_PHONE_TYPES = [REQUEST_A_CALL.component];
const REQUIRED_NAME_TYPES = [REQUEST_A_CALL.component, SAVE_AND_RETRIEVE_QUOTE.component];
const REQUIRED_PRIVACY_POLICY_TYPES = [REQUEST_A_CALL.component];

const getCustomEmailMessage = () => 'Enter a valid email address';

const getCustomCheckboxMessage = () => 'Select the required checkbox';

// @ts-expect-error - Automatic, Please fix when editing this file
const isRequired = (component, leadComponentType, message) =>
  includes(component, leadComponentType) ? required(message) : '';

// @ts-expect-error - Automatic, Please fix when editing this file
const generateSchema = (component, serverCookieValue?: string) => {
  const memberId = getCookieForMembers('health', { serverCookieValue })?.id;

  const schema: Schema = {
    email: {
      initialValue: '',
      linkPhrases: ['email address'],
      validation: [
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'Validator' is not assignable to type 'NestedValidator'.
        email(getCustomEmailMessage()),
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'Validator' is not assignable to type 'NestedValidator'.
        maxLength(255),
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | Validator' is not assignable to type 'NestedValidator'.
        isRequired(component, REQUIRED_EMAIL_TYPES, getCustomEmailMessage()),
      ],
    },
    isMember: {
      initialValue: memberId !== undefined,
    },
    memberCallbackReason: {
      initialValue: '',
      validation: [
        conditional(
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type '({ isMember }: { isMember: boolean; }) => boolean' is not assignable to parameter of type 'ConditionalRule'.
          ({ isMember }: { isMember: boolean }) => isMember && component === REQUEST_A_CALL.component,
          [required()],
        ),
      ],
    },
    memberId: {
      initialValue: memberId ?? '',
      validation: [
        conditional(
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type '({ isMember }: { isMember: boolean; }) => boolean' is not assignable to parameter of type 'ConditionalRule'.
          ({ isMember }: { isMember: boolean }) => isMember && component === REQUEST_A_CALL.component,
          [required(), minLength(8, 'We’re missing something … it should be 8 numbers')],
        ),
      ],
    },
    [`marketingOptIn-${component}`]: {
      initialValue: false,
      validation: [
        conditional(
          () => component === LEAD_TYPES.SAVE_AND_RETRIEVE_QUOTE.component,
          [required(), checked(getCustomCheckboxMessage())],
        ),
      ],
    },
    name: {
      initialValue: '',
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | Validator' is not assignable to type 'NestedValidator'.
      validation: [isRequired(component, REQUIRED_NAME_TYPES, DEFAULT_VALIDATION_ERROR), maxLength(200)],
    },
    phone: {
      initialValue: '',
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'string | Validator' is not assignable to type 'NestedValidator'.
      validation: [isRequired(component, REQUIRED_PHONE_TYPES, DEFAULT_VALIDATION_ERROR), phone()],
    },
    [`privacyAgreement-${component}`]: {
      initialValue: !includes(component, REQUIRED_PRIVACY_POLICY_TYPES),
      linkPhrases: ['required checkbox'],
      validation: [
        conditional(
          () => includes(component, REQUIRED_PRIVACY_POLICY_TYPES),
          [required(), checked(getCustomCheckboxMessage())],
        ),
      ],
    },
  };

  return { packagedSchema: packageSchemaForFormik(schema), rawSchema: schema };
};

export default generateSchema;
